// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1DbsQYlFK_zoYy2EWeoXJt {\r\n    position: relative;\r\n\r\n    box-shadow: 6px 6px 15px rgba(0,0,0,0.15);\r\n    border-radius: 5px;\r\n    background-color: var(--card);\r\n    color: var(--on-card);\r\n}\r\n\r\n._2DM7xxjlWjxiSWQLr2IShY {\r\n    cursor : pointer;\r\n    transition: background-color 0.2s ease-in-out;\r\n}\r\n\r\n._2DM7xxjlWjxiSWQLr2IShY:hover { background-color: var(--card-light); }\r\n._2DM7xxjlWjxiSWQLr2IShY:hover ._330Qv9Crv35CCLr43JEN6n { background-color: var(--card-secondary-light); }\r\n._2DM7xxjlWjxiSWQLr2IShY ._3BOfpnu41ET9CbxO4dDx9g { transition: background-color 0.2s ease-in-out; }\r\n\r\n._3BOfpnu41ET9CbxO4dDx9g {\r\n    background-color: var(--card-secondary);\r\n\r\n    margin: 0 9px;\r\n    padding: 0 9px; \r\n    border-radius: 5px;\r\n}", ""]);
// Exports
exports.locals = {
	"container": "_1DbsQYlFK_zoYy2EWeoXJt",
	"clickable": "_2DM7xxjlWjxiSWQLr2IShY",
	"insert": "_330Qv9Crv35CCLr43JEN6n",
	"inset": "_3BOfpnu41ET9CbxO4dDx9g"
};
module.exports = exports;
